import { useGetHasEntitlement } from './useGetHasEntitlement.hook';
import { useProductStatus } from './useProductStatus.hook';
import { EntitlementType } from '@/@types/entitlement';
import { ProfileBenefitsStatusResponse } from '@/@types/productBenefits';
import { ProductsStatusKey } from '@/@types/productsStatus';
import { getSessionStorageItem } from '@/utils/session';

export const useIsKeyAndLegalAvailable = (): boolean => {
  const isEntitled = useGetHasEntitlement(EntitlementType.KEY_AND_LEGAL_SERVICE);
  const product = useProductStatus(ProductsStatusKey.ProfileBenefits);
  const keyEmergencyServiceActive = (product as ProfileBenefitsStatusResponse)?.keyEmergencyService;
  const rentLegalAdviceActive = (product as ProfileBenefitsStatusResponse)?.rentLegalAdvice;

  if (!isEntitled) {
    return false;
  }

  if (keyEmergencyServiceActive || rentLegalAdviceActive) return true;
  return getSessionStorageItem('isSessionEntitledForKeyAndLegal') ?? false;
};
